<template>
  <common-dialog ref="dialog" :title="title" width="1200px" :in-dialog="inDialog">
     <list ref="list" common :show-checkbox="multiple" is-select :show-type="showType">
          <template #column>
            <slot name="column" />
            <template v-if="selectable&&!multiple">
              <el-table-column label="操作" align="center" width="60" fixed="right">
                <template slot-scope="{row}">
                  <el-button @click="onSelect(row)" type="text">选择</el-button>
                </template>
              </el-table-column>
            </template>
          </template>
        </list>
    <template slot="footer">
      <slot name="footer">
        <el-button type="primary" @click="selectMultiple" v-if="selectable&&multiple">选择</el-button>
      </slot>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import list from "./list";
import listDialogMixins from "@/mixins/listDialog";

export default {
  components: { commonDialog, list },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "存货列表",
    },
  },
  data() {
    return {
      params: {},
      showType: true,
    };
  },
  methods: {
    getData(params = {}) {
      this.params = { ...params };
      this.$refs.list.getData(this.params);
    },
  
  },
};
</script>